import React from 'react'
import { TagItem } from '.'
import Select from 'react-select'

const TagAdder = () => {
  return (
    <div>
      <div className="flex flex-wrap">
        <div className="mr-3 mb-3">
          <TagItem value="Perdamaian"/>
        </div>
        <div className="mr-3 mb-3">
          <TagItem value="Islam"/>
        </div>
        <div className="mr-3 mb-3">
          <TagItem value="Peradaban Agama"/>
        </div>
        <div className="mr-3 mb-3">
          <TagItem value="Pemerintah"/>
        </div>
        <div className="mr-3 mb-3">
          <TagItem value="Bangka Belitung"/>
        </div>
        <div className="mr-3 mb-3">
          <TagItem value="NGO"/>
        </div>
      </div>
      <Select className="text-sm" options={[]} placeholder="Search tag"/>
    </div>
  )
}

export { TagAdder }